var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGbfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_4265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#43E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3823 22.6471C17.763 22.6471 18.8823 21.5278 18.8823 20.1471C18.8823 18.7664 17.763 17.6471 16.3823 17.6471C15.0016 17.6471 13.8823 18.7664 13.8823 20.1471C13.8823 21.5278 15.0016 22.6471 16.3823 22.6471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9117 22.6471C25.2925 22.6471 26.4117 21.5278 26.4117 20.1471C26.4117 18.7664 25.2925 17.6471 23.9117 17.6471C22.531 17.6471 21.4117 18.7664 21.4117 20.1471C21.4117 21.5278 22.531 22.6471 23.9117 22.6471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9811 11.2941L28.5647 28.7059H22.2117L22.7717 26.8235H27.1811L31.4306 13.1765H26.8141L27.3741 11.2941H33.9811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8188 13.1765L8.56939 26.8235H13.6564L13.0964 28.7059H6.0188L11.4306 11.2941H18.2588L17.7035 13.1765H12.8188Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_4265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbfs);
export default __webpack_public_path__ + "static/media/gbfs.6ec409d058bd9f4f3dfc86ee51df1742.svg";
export { ForwardRef as ReactComponent };